import React, { useState, useRef, useEffect } from 'react'
import './FilterDropDown.scss'

export default function FilterDropDown({
  selectedItem,
  onItemChanged,
  menuItems,
}) {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
      document.addEventListener('keydown', handleEscape)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen])

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  const handleItemClick = (value) => {
    onItemChanged(value)
    setIsOpen(false)
  }

  return (
    <div className="filter-dropdown" ref={dropdownRef}>
      <button 
        type="button"
        className="filter-trigger"
        onClick={handleToggle}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        ▼
      </button>
      
      {isOpen && (
        <div className="filter-menu" role="listbox">
          {menuItems.map(({ text, value }) => (
            <div
              key={value}
              role="option"
              className={`filter-option ${value === selectedItem ? 'selected' : ''}`}
              onClick={() => handleItemClick(value)}
              aria-selected={value === selectedItem}
            >
              <p>{text}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
